/**
 *
 * @param name
 */
export const sendEvent = (
  name: string = "default",
  data: object = {},
): void => {
  const value = getCookie("devduck_ga");
  if (value === "true" && (window as any).gtag)
    (window as any).gtag("event", name, {
      ...data,
    });
};

/**
 * Helper to fetch Cookie with plain Java
 * @param name name of cookie
 * @returns return value as string
 */
export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }

  return null;
};
